var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { upperCase } from 'lodash';
import { queue_email_operation } from '../1_queue_email_operation/queue_email_operation';
const dataKeys = ['recipients', 'subject', 'body'];
export function getSendEmailTestFormProps() {
    return {
        modeProp: 'editRecord',
        columnsProp: dataKeys.map((key) => ({
            name: key,
            label: upperCase(key),
            inlineEdit: true,
        })),
        executeOnSubmit: (request) => __awaiter(this, void 0, void 0, function* () {
            const requestToEmailProvider = {
                operation_type: 'send_email',
                metadata: { source: 'test_form' },
                to_recipients: request.recipients.split(',').map((email) => ({
                    address: email.trim()
                })),
                subject: request.subject,
                text_body: request.body,
            };
            yield queue_email_operation(requestToEmailProvider);
        }),
    };
}
